import { render, staticRenderFns } from "./AllUsers.vue?vue&type=template&id=253ef608&scoped=true"
import script from "./AllUsers.vue?vue&type=script&lang=js"
export * from "./AllUsers.vue?vue&type=script&lang=js"
import style0 from "./AllUsers.vue?vue&type=style&index=0&id=253ef608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ef608",
  null
  
)

export default component.exports